import { Injectable } from '@angular/core'
import { BehaviorSubject, from, of } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { environment } from '../../../environments/environment'
import { NGXLogger } from 'ngx-logger'

export interface IDialog {
  text: string,
  isQuestion: boolean,
  type: string
}

@Injectable({
  providedIn: 'root'
})
export class ChatState {
  constructor(
    public logger: NGXLogger,
  ) { }
  private _chatDisplaySource = new BehaviorSubject(false)
  private _dialogMessages = new BehaviorSubject({ text: 'How can we help you?', isQuestion: false, type: 'Feedback' })
  private _dialogBubbles = new BehaviorSubject([])
  private _initialActivity = new BehaviorSubject(null as string)


  public observables = {
    chatDisplayState : this._chatDisplaySource.asObservable(),
    dialogMessages : this._dialogMessages.asObservable(),
    dialogBubbles : this._dialogBubbles.asObservable(),
    initialActivity : this._initialActivity.asObservable(),
  }


  public state = {
    messageHistory:  [] as IDialog[],
    lastBubbles: null as any,
    isInitedWithText : false,
    lastInput : null as any,
    lastInputRetrieved : null as any,
    isChatOpened : false,

  }


  public initActivity(activity) {
    this.state.lastInput = activity
    this.state.isInitedWithText = true
    this._initialActivity.next(activity)
  }

  public toggleChat(state: boolean) {
    this._chatDisplaySource.next(state)
    this.state.isChatOpened = state
  }
  public addDialogMessage(message: IDialog) {
    this._dialogMessages.next(message)
  }
  public addDialogBubbles(bubbles: string[]) {
    if (bubbles.length !== 0) {
      this._dialogBubbles.next(bubbles)
    }
  }

}

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  api: string = environment.CHAT_API_URL
  conversationId: string
  chatId: number
  latestRequestBody: any

  constructor(
    public logger: NGXLogger,
    private http: HttpClient,
    private chatState: ChatState) {}



  private createNewActivityBodyFromText(text) {
    return {
      conversationId: this.conversationId,
      chatId: 6988,
      text,
      from: {
        id: this.chatId,
        name: 'TestName'
      }
    }
  }

  private validateLatestBodyWith(body) {
    if (this.latestRequestBody === JSON.stringify(body)) {
      this.logger.info('===Block twice request')
      throw new Error('Block twice request')
    }
  }

  private async onConversationStarted(text): Promise<any> {
      const body = this.createNewActivityBodyFromText(text)
      this.validateLatestBodyWith(body)
      this.latestRequestBody = JSON.stringify(body)

      const res: any = await this.http.post(`${this.api}/sendactivity`, body).toPromise()
      this.chatState.state.lastBubbles = res.suggestedActions?.actions?.map(v => v.value)

      this.logger.info('CHAT activity response: ' + JSON.stringify(res))
      return res
  }

  public async startConversation() {
    const res: any = await this.http.get<any>(`${this.api}/startconversation`).toPromise()
    this.logger.info('CHAT: startconversation response: ' + JSON.stringify(res))
    this.conversationId = res.conversationId
    this.chatId = res.chatId
    this.chatState.addDialogBubbles(res.defaultBubbles)
    this.logger.info('CHAT: conversation started')
    return res.defaultBubbles
  }

  public sendActivity(text: string): Observable<any> {
    if (this.conversationId === '' || this.conversationId === undefined || this.conversationId === null) {
      return from(this.startConversation()
        .then(async () => this.onConversationStarted(text)))
    }
    return from(this.onConversationStarted(text))
  }
}

